/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationSummaryResponse {
    getFixupPrototypeFunction() { return ScheduleRecommendationSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationSummaryResponse>): ScheduleRecommendationSummaryResponse {
        let obj = Object.assign(new ScheduleRecommendationSummaryResponse(), model);
        ScheduleRecommendationSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationSummaryResponse>): ScheduleRecommendationSummaryResponse {
        if (!model) return null;
        return ScheduleRecommendationSummaryResponse.newInstance(<ScheduleRecommendationSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationSummaryResponse) {
        if (!obj) return;

        models.ScheduleRecommendationSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationSummaryResponse): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.potential_savings === undefined) {
            this.potential_savings = 0;
        }
        if (this.weekly_recommendations === undefined) {
            this.weekly_recommendations = 0;
        }
        if (this.hourly_recommendations === undefined) {
            this.hourly_recommendations = 0;
        }
        if (this.impacting_resources === undefined) {
            this.impacting_resources = 0;
        }
    }

    /**
     * Potential Cost Savings
     */
    potential_savings: number;

    /**
     * Count of Weekly Recommendations
     */
    weekly_recommendations: number;

    /**
     * Count of Hourly Recommendations
     */
    hourly_recommendations: number;

    /**
     * Count of Impacting Resources
     */
    impacting_resources: number;

}
